/**
 * Serialize a value as JSON for embedding inside a `<script type="application/ld+json">`
 * tag via dangerouslySetInnerHTML.
 *
 * Plain JSON.stringify is NOT safe here: a `<`, `>`, `&`, or a `</script>` sequence in any
 * string value passes through verbatim and can close the script element early, letting
 * attacker-controlled schema content (blog titles, API descriptions, author bios) break out
 * of the tag and execute as markup. We escape those characters as unicode escapes, which JSON
 * parsers decode back to the original character, so the emitted structured data is unchanged
 * while the HTML is inert. The U+2028 / U+2029 line separators are also escaped: they are legal
 * inside a JSON string but terminate a line in a JS parsing context.
 */

// Built from char codes so this source file contains no literal separator characters.
const LINE_SEP = String.fromCharCode(0x2028);
const PARA_SEP = String.fromCharCode(0x2029);
const UNSAFE = new RegExp(`[<>&${LINE_SEP}${PARA_SEP}]`, 'g');

export function serializeJsonLd(data: unknown): string {
  return JSON.stringify(data).replace(
    UNSAFE,
    (ch) => '\\u' + ch.charCodeAt(0).toString(16).padStart(4, '0'),
  );
}
